import React from 'react'

const webFrame = (props) => {
  const { className, title, iframeSrc } = props
  return(
    <div className={className ? className : ''}>
      <h1>{title}</h1>
      <iframe src={iframeSrc}></iframe>
    </div>
  )
}

export default webFrame